export const CHAT_INIT = 'chatInit'
export const CHAT_GET_OPENAI_STATUS = 'chatGetOpenAIStatus'
export const CHAT_SET_PERSONA = 'chatSetPersona'
export const CHAT_GET_SHORTID = 'chatGetShortId'